/* eslint-disable no-nested-ternary */
import React from 'react';
import Banner from '@hig/banner';
import log from 'loglevel';

// Actions and Utils
import getHULA from '../../Action/getHULA/getHULA';
import pushGTMEvent from '../../util/helper/pushGTMEvent';

// handlers.
import { handleSerialInputChange, handleSerialInputValidation } from '../../handler/handleSerialInputChange';
import handleProductInputChange from '../../handler/handleProductInputChange';
import handleVersionChange from '../../handler/handleVersionChange';
import { isRUorJA } from '../../App/App.config';

const configContents = ({
  state: {
    credentials,
    currentHULADetails,
    errors,
    productInfoPage,
    serialNumberAndProductName, 
    langStrings,
  }, 
  dispatch,
}) => {
  const contents = [
      {
        isTitle: true,
        hasLargeBottom: true,
        description: langStrings.processInfoScreen.pageTitle || '2. Product information',
        paragraphStyle: { marginBottom: isRUorJA && '-20px' },
      },
      {
        isShown: errors.isTFLEX,
        isCustomComponent: true,
        customComponent: <Banner type="primary">
          {langStrings.hula.errors.tokenFlexSerialNumber.split('<strong>')[0]
          }
          <strong>
            <a href="mailto:premier@autodesk.com">premier@autodesk.com</a>
          </strong>
        </Banner>,
        paragraphStyle: { marginBottom: '7px' },
      },
      {
        description: langStrings
          ? langStrings.processInfoScreen.serialNumberLabel
          : 'Serial number',
        style: { fontWeight: 600 },
        paragraphStyle: { marginBottom: '5px' },
        endWithRedStar: true,
        endWithInfoCircle: true,
        hoverInfoDescriptions: langStrings
          ? langStrings.processInfoScreen.serialNumberTooltip
          : 'How to find your <a target="_blank" href="https://www.autodesk.com/find-request-code-eng">request code</a>',
      },
      {
        isShown: errors.invalidSerialNumber,
        description: langStrings
          ? langStrings.errors.invalidSerialNumber
          : 'Invalid serial number',
        style: { fontWeight: 400, color: '#ec4a41', fontSize: '14px' },
        paragraphStyle: { marginBottom: '5px' },
        id: 'adsktm-hula-serial-number-error',
      },
      {
        isTextInput: true,
        placeholder: langStrings
          ? langStrings.processInfoScreen.serialNumberPlaceholder
          : 'Search by name - or - type a number',
        handleChange: (e) => handleSerialInputChange(e, currentHULADetails, dispatch, credentials),
        datalist: currentHULADetails.datalist,
        autoComplete: false,
        focusIn: !serialNumberAndProductName && currentHULADetails.datalist && currentHULADetails.datalist.length > 0 && !errors.invalidSerialNumber,
        isLoading: currentHULADetails.isLoading,
        showGreenTick: currentHULADetails.showGreenTick,
        showClose: serialNumberAndProductName.length !== 0 && currentHULADetails.showClose,
        isError: errors.invalidSerialNumber,
        value: serialNumberAndProductName,
        handleClose: () => {
          log.debug("close button clicked!");
          dispatch({ type: 'CLICK_CLOSE_ICON' })
        },
        handleSubmit: () => {}, // prevent ENTER key
        handleValidation: (e) => handleSerialInputValidation(e, currentHULADetails, langStrings, errors, dispatch, credentials),
      },
      {},
      {
        isShown: errors.isMultiUserDeployment,
        BGColor: '#f7fcfe',
        BGPadding: '20px 20px 20px',
        description: langStrings
          ? langStrings.processInfoScreen.doNotNeedHula
          : 'Bic Asset',
        style: {
          color: '#333',
          fontSize: '14px',
          marginbottom: '20px',
        },
        paragraphStyle: { marginBottom: '20px', marginTop: '-20px'},
        id: 'adsktm-hula-multiuser-deployment-banner',
      },
      {
        isShown: errors.hulsNotEligible,
        BGColor: '#f7fcfe',
        BGPadding: '20px 20px 20px',
        description: langStrings
          ? langStrings.processInfoScreen.msgSN2010orOlder
          : 'The serial number you entered is for an older version that is no longer supported. <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">See eligibility requirements</a>',
        style: {
          color: '#333',
          fontSize: '14px',
          marginbottom: '20px',
        },
        paragraphStyle: { marginBottom: '20px', marginTop: '-20px'},
        id: 'adsktm-hula-no-longer-supported-banner',
      },
      {
        // by default valus of isHULAEligible= true, it will be false if there is an error.
        isShown: !errors.isHULAEligible,
        BGColor: '#f7fcfe',
        BGPadding: '20px 20px 20px',
        description: langStrings
          ? langStrings.processInfoScreen.ineligiblePerpetual
          : 'Bic Asset',
        style: {
          color: '#333',
          fontSize: '14px',
          marginbottom: '20px',
        },
        paragraphStyle: { marginBottom: '20px', marginTop: '-20px'},
        id: 'adsktm-hula-ineligible-perpetual-banner',
      },
      {
        isShown: productInfoPage.showProductDropdown && currentHULADetails.showClose,
        description: langStrings
          ? langStrings.processInfoScreen.partOfCollection.replace('<collection-name>',currentHULADetails.colName)
          : 'Your product is part of this collection: '('<collection-name>', currentHULADetails.colName),
        style: { 
          fontWeight: 600,
          marginTop: '-10px',
         },
        paragraphStyle: { marginBottom: '5px' },
      },
      {
        isShown: productInfoPage.showProductDropdown && currentHULADetails.showClose,
        description: langStrings
          ? langStrings.processInfoScreen.selectProduct
          : 'Select your specific product',
        style: { fontWeight: 600 },
        paragraphStyle: { marginBottom: '5px' },
        endWithRedStar: true,
      },
      {
        isShown: productInfoPage.showProductDropdown && currentHULADetails.showClose,
        isDropdown: true,
        handleChange: option => handleProductInputChange(
          option,
          currentHULADetails,
          productInfoPage,
          dispatch,
          credentials,
          ),
        placeholder: langStrings
          ? langStrings.processInfoScreen.selectPlaceholder
          : 'Select',
        options: currentHULADetails.prodList,
        value: currentHULADetails.selectedProduct,
        paragraphStyle: { marginBottom: '20px' },
      },
      {
        isShown: productInfoPage.showVersionDropdown && currentHULADetails.showClose,
        description: langStrings
          ? langStrings.pv.processInfoScreen.versionRequestingLabel
          : 'Version you’re requesting',
        style: { fontWeight: 600 },
        paragraphStyle: { marginBottom: '5px' },
        endWithRedStar: true,
      },
      {
        isShown: productInfoPage.showVersionDropdown && currentHULADetails.showClose,
        isDropdown: true,
        handleChange: option => handleVersionChange(
          option,
          currentHULADetails,
          dispatch,
          ),
        placeholder: langStrings
          ? langStrings.processInfoScreen.selectPlaceholder
          : 'Select',
        options: currentHULADetails.productVersions,
        value: currentHULADetails.selectedProductVersion,
        paragraphStyle: { marginBottom: '12px' },
      },
      {
        isShown: productInfoPage.showVersionDropdown && currentHULADetails.showClose,
        description: langStrings
          ? langStrings.hula.processInfoScreen.hulaEligibleVersionMsg
          : 'Only eligible versions are listed above. <a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-eng">See eligibility requirements</a>',
        style: { 
          fontStyle: 'italic',
          fontSize: '12px',
          fontWeight: 500,
         },
        paragraphStyle: { marginBottom: '5px' },
      },
      {
        // by default valus of isHULAEligible= true, it will be false if there is an error.
        isShown: errors.crossGradeHula,
        BGColor: '#f7fcfe',
        BGPadding: '20px 20px 20px',
        description: langStrings
          ? langStrings.hula.processInfoScreen.crossGradeHulaMessage
          : `We can't process your request here. To get a home use license for the selected version, please <a id="go-to-create-case" href="javascript:void(0);">create a case.</a> We will get back to you in 2 business days.`,
        style: {
          color: '#333',
          fontSize: '14px',
          marginbottom: '20px',
        },
        paragraphStyle: { marginBottom: '20px', marginTop: '20px'},
        id: 'adsktm-hula-cross-grade-hula-banner',
      },
  ]

  return contents;
};

const configFooter = ({
  state: {
    credentials,
    currentHULADetails,
    errors,
    hasExtension,
    langStrings,
    productInfoPage,
    user,
  },
  dispatch,
}) => {
  const { isMultiUserDeployment, isHULAEligible, hulsNotEligible, crossGradeHula} = errors
  const showCloseButton = isMultiUserDeployment || !isHULAEligible || hulsNotEligible || crossGradeHula;
  const { datalist } = currentHULADetails;
  const serialNumberList = datalist && datalist.length > 0 && datalist.map((data)=> {
    const serialNumber = data.split('     ')[0];
    return serialNumber;
  });
  const showSubmitButton = serialNumberList && serialNumberList.length > 0 && serialNumberList.includes(currentHULADetails.serialNumber);
  
  const expandHulaCond1 = errors.crossGradeHula && productInfoPage.showProductDropdown;
  
  return {
    requiredDisclaimer: true,
    hasQuestion: true,
    hasExtension,
    nextButtonContent:  showCloseButton ? langStrings.buttons.closeButton :
      showSubmitButton ? langStrings.buttons.submitButton : langStrings.buttons.nextButton,
    handleBack: () => {
      pushGTMEvent('ContactInfo');
      dispatch({ type: 'GO_TO_REVIEW_ACCOUNT_PAGE' });
    },
    handleNext: async () => {
      log.debug('DATA LIST : ', currentHULADetails.datalist.length);
      if(showCloseButton) {
        dispatch({ type: 'RESTART_WIDGET' })
        return window.location.reload(true);
      } 
      if(showSubmitButton) {
        try {
          return await getHULA(langStrings, user, currentHULADetails, dispatch, credentials);
        } catch(e) {
          console.log(' Error : ', e);
          return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' });
        }
      }
      // because user entered serial Number which he is not authorized to.
      console.log('PAGE : GO_TO_AUTHORIZE_PAGE');
      return dispatch({ type: 'GO_TO_AUTHORIZE_PAGE'});
    },
    handleAgentLoad: () => dispatch({ type: 'AGENT_LOADED' }),
    handleAgentAvailable: (flag) => dispatch({ type: 'AGENT_AVALIABLE', payload: { isAgentAvailable: flag } }),
    handleAgentAnalytics: () => pushGTMEvent('ChatWithAgent'),
    handleCaseAnalytics: () => pushGTMEvent('CreateCase'),
    handleNextButtonId: 'adsktm-hula-next-button',
    handleBackButtonId: 'adsktm-hula-back-button',
    requiredDisclaimerId: 'adsktm-required-disclaimer-text',
    handleAgentButtonId: 'adsktm-agent-button',
    handleCaseButtonId: 'adsktm-case-button',
    handleQuestionButtonId: 'adsktm-have-question-button',
    // eslint-disable-next-line no-unneeded-ternary
    enableNextButton: currentHULADetails.selectedProductVersion || showCloseButton,
    handleSupportAnalytics: () => pushGTMEvent('ContactSupport'),

    // expand HULA 200px more.
    expandForHULA: expandHulaCond1,
  }
};

export default {
  configContents,
  configFooter,
};
